import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import * as moment from 'moment-timezone';
import { AppState } from 'src/app/state/app-state';
import { CONFIG, EL_PATRON_INIT } from 'src/app/state/app.reducer';
import { AppService } from 'src/core/services/app.service';
import { BootstrapService } from 'src/core/services/bootstrap.service';
import { ConfigurationService } from 'src/core/services/configuration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  public bootstrapPromise: Promise<any>;
  public isLoggedIn = false;

  private patronClientIdDev = 'af4d6859594d43518c776c1538b249a9';

  constructor(
    private appService: AppService,
    private configurationService: ConfigurationService,
    private store: Store<AppState>,
    private bootstrapService: BootstrapService,
  ) {}

  ngOnInit() {
    const redirectURI = `&redirect_uri=${window.location.protocol}//${window.location.host}`;
    const returnToApp = `&return_to_app=true`;
    moment.locale('es-MX');

    this.configurationService.load().then((result: any) => {
      const elPatron: any = result.EL_PATRON;
      /// Para que en modo DEV no haga el redirect
      const SILENT_URL =
        elPatron.CLIENT_ID === this.patronClientIdDev
          ? `${elPatron.SILENT_URL}`
          : `${elPatron.SILENT_URL}${redirectURI}`;
      this.store.dispatch({
        type: EL_PATRON_INIT,
        payload: {
          URL_SIGNIN: elPatron.URL_SIGNIN,
          URL_SIGNOUT: elPatron.URL_SIGNOUT,
          URL_MFA: elPatron.URL_MFA,
          URL_SETTINGS: `${elPatron.URL_SETTINGS}${redirectURI}${returnToApp}`,
          URL_SET_MFA: elPatron.URL_SET_MFA,
          URL_CHALLENGE: elPatron.URL_CHALLENGE,
          URL_REFRESH: elPatron.URL_REFRESH,
          CLIENT_ID: elPatron.CLIENT_ID,
          URL_TOKEN_INFO: elPatron.URL_TOKEN_INFO,
          URL_UPGRADE_SESSION: elPatron.URL_UPGRADE_SESSION,
          URL_DELETE_OPERATIVE_SESSION: elPatron.URL_UPGRADE_SESSION,
          GET_PARTY_URL: elPatron.GET_PARTY_URL,
          SILENT_URL,
          GBMCOM_DASHBOARD: elPatron.GBMCOM_DASHBOARD,
          GBMCOM_URL: elPatron.GBMCOM_URL,
        },
      });

      this.store.dispatch({
        type: CONFIG,
        payload: {
          api: result.api,
          appId: result.app,
          deviceId: result.dev,
          gbmComApi: result.GBM_COM_API,
          loremApi: result.LOREM_API,
          priceAlertsApi: result.PRICE_ALERTS_API,
          tradingUsaApi: result.TRADING_USA_API,
          comBankAccountUrl: result.DOTCOM.BANK_ACCOUNT,
          comBlackUpgrade: result.DOTCOM.BLACK_UPGRADE,
          newsApi: result.NEWS_API,
          ujetAuthUrl: result.UJET_AUTH_URL,
          userPreferencesApi: result.user_preferences_api,
        },
      });

      this.appService.init();
    });

    this.isLoggedIn = true;
    this.bootstrapPromise = this.bootstrapService.initSession();
  }
}
